<script setup lang="ts">
defineProps<Props>()
const modelValue = defineModel()
interface Props {
  disabledAnimation?: boolean
}
</script>

<template>
  <div
    class="inline-block"
    @click="modelValue = !modelValue"
  >
    <div
      class="h-btn disabled"
      :class="{ open: modelValue && !disabledAnimation }"
    >
      <span />
      <span />
      <span />
      <span />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.h-btn {
  width: 1em;
  height: 0.85em;
  position: relative;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 0.1em;
    width: 100%;
    background: currentcolor;
    border-radius: 9px;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      top: 0;
    }

    &:nth-child(2) {
      visibility: hidden;
    }

    &:nth-child(2),
    &:nth-child(3) {
      top: 0.3em;
    }

    &:nth-child(4) {
      top: 0.6em;
    }
  }

  &.open {
    transition: 0.2s ease-in-out;
    transition-delay: 0.1s;
    transform: rotate(-90deg);

    span {
      &:nth-child(1) {
        top: 0.3em;
        width: 0%;
        left: 50%;
      }

      &:nth-child(2) {
        visibility: visible;
        transform: rotate(45deg);
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
      }

      &:nth-child(4) {
        top: 0.3em;
        width: 0%;
        left: 50%;
      }
    }
  }
}
</style>
